import { render, staticRenderFns } from "./LuckDraw2.vue?vue&type=template&id=8b1655da&scoped=true&"
import script from "./LuckDraw2.vue?vue&type=script&lang=js&"
export * from "./LuckDraw2.vue?vue&type=script&lang=js&"
import style0 from "./LuckDraw2.vue?vue&type=style&index=0&id=8b1655da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b1655da",
  null
  
)

export default component.exports